import api from 'api';
import DesignTemplate from 'records/DesignTemplate';

export const USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_START = 'USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_START';
export const USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS = 'USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR = 'USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR';
export const USE_AGAIN_DESIGN_TEMPLATES_RESET_STATE = 'USE_AGAIN_DESIGN_TEMPLATES_RESET_STATE';

function useItAgainDesignTemplatesAsyncActionStart() {
  return {
    type: USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  };
}

function useItAgainDesignTemplatesAsyncActionError(error) {
  return {
    type: USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function useItAgainDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetuseItAgainDesignTemplatesState() {
  return {
    type: USE_AGAIN_DESIGN_TEMPLATES_RESET_STATE,
  };
}

export function getuseItAgainDesignTemplates(designTypeId, designSizeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(useItAgainDesignTemplatesAsyncActionStart());
    return api.request(
      `design/DesignTemplates/useitagain?designtid=${ designTypeId }&sizeid=${ designSizeId }&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(useItAgainDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(useItAgainDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function getuseItAgainThemeDesignTemplates(layoutId) {
  return (dispatch, getState) => {
    dispatch(useItAgainDesignTemplatesAsyncActionStart());
    return api.request(
      `design/DesignTemplates/useitagain?layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(useItAgainDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(useItAgainDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function filteruseItAgainThemeDesignTemplates(designTypeId, designSizeId,layoutId) {
  return (dispatch, getState) => {
    dispatch(useItAgainDesignTemplatesAsyncActionStart());
    let useItAgainData = getState().useItAgainDesignTemplates.get('data');
    let filterData = DesignTemplate.getDesignTemplatesByTypeAndSizeId(useItAgainData, designTypeId, designSizeId);
    let filterLayoutData = filterData;
    if(layoutId!=undefined){
      filterLayoutData=DesignTemplate.getDesignTemplatesByLayoutId(filterData, layoutId);
    }
    if(filterLayoutData.size==0){
      dispatch(getuseItAgainDesignTemplates(
        designTypeId,
        designSizeId,
        layoutId
      ));
    }else{
      dispatch(resetuseItAgainDesignTemplatesState());
      dispatch(useItAgainDesignTemplatesAsyncActionSuccess(filterLayoutData));
    }
  };
}
